import(/* webpackMode: "eager" */ "/home/runner/work/hypertask-static-homepage/hypertask-static-homepage/src/app/(main)/page.tsx");
